import React from 'react';

export default function NotFound(props) {
    return <h1>Not Found</h1>;
  }
